import { Box, ThemeContext} from 'grommet';
import React, { useContext}from 'react';
import { DisplayInlineBlockBox, UnderlinedText } from '../utils/styled';
import { NotificationsContext } from './NotificationsProvider';
import { useRouter } from 'next/router';
import DropButton from './DropButton';
import InvoiceTag from './InvoiceTag';
import { INVOICE_CARD_MAX_WIDTH } from '../constants/Dimensions';
const MultipleInvoiceTags = ({ ids, inline = false }) => {
    if (inline) {
        return (
            <Box justify="center" wrap={true} width={{ max: '300px' }} direction='row' gap='xsmall'>
                {ids.map((id) => (
                    <Box key={id} margin={{ vertical: 'xxsmall' }}>
                        <InvoiceTag id={id} />
                    </Box>
                ))}
            </Box>
        );
    } else {
        return (
            <DisplayInlineBlockBox>
                <DropButton
                    label={<UnderlinedText>{ids.length} invoices</UnderlinedText>}
                    event={{ section: 'multiple_invoice_tag_drop_button', element: 'show_invoice_tags', description: ids?.join(",") }}
                    plain
                    hoverIndicator
                    dropAlign={{ top: 'bottom' }}
                    dropProps={{ border: true, margin: { vertical: 'xsmall' } }}
                    dropContent={
                        <Box margin='xsmall' pad='xxsmall' justify="center" wrap={true} width={{ max: '300px' }} direction='row' gap='xsmall'>
                            {ids.map((id) => (
                                <Box key={id} margin={{ vertical: 'xxsmall' }}>
                                    <InvoiceTag id={id} />
                                </Box>
                            ))}
                        </Box>
                    }
                />
            </DisplayInlineBlockBox>
        );
    }
};

export default MultipleInvoiceTags;